import React from "react";
import {
	StyleSheet,
} from "react-native";

import StyledIcon from "../Base/StyledIcon";

import Style from "ae-style";

const styles = StyleSheet.create({
	icon: {
		marginRight: Style.layout.marginSmall,
	}
});

export default function ListIcon(props){
	const name = props.name;

	return (
		<StyledIcon style={styles.icon} name={name} />
	);
}
